import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { subcontractorOverviewService } from '@services/subcontractor/subcontractor';
import { SubcontractorRosterEntry } from '@models/subcontractor.model';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const SUBCONTRACTOR_ROSTER_QUERY_KEY = 'subcontractorRoster';

// Sprint 25, story-134. Attention-sorted roster: overdue + awaiting approval + open incidents
// descending, then name ascending (server-computed, per docs/ux/story-134-design.md).
export const useSubcontractorRoster = (): UseQueryResult<SubcontractorRosterEntry[], Error> => {
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  return useQuery({
    queryKey: [SUBCONTRACTOR_ROSTER_QUERY_KEY, organizationId],
    queryFn: () => subcontractorOverviewService.getRoster(),
    enabled: !!organizationId,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export default useSubcontractorRoster;
